import "./requires";
import ajax from "./ajax";
import WebFont from "webfontloader";

// Init vue
import { createApp, nextTick, h } from "vue";
import { createI18n } from "vue-i18n";
import { ruChoiceIndex } from "./helpers/vue_i18n";
import { createRouter, createWebHistory } from "vue-router";
import { eventBus, EVENTS } from "./event_bus";
const messages = window.envs.messages;
const initialLocale = Object.keys(messages)[0];
const i18n = createI18n({
  locale: initialLocale,
  fallbackLocale: initialLocale,
  formatFallbackMessages: true,
  allowComposition: true,
  messages,
  pluralizationRules: {
    'ru': ruChoiceIndex,
    'ru-RU': ruChoiceIndex
  }
});
function preventDefaults(e) {
  e.preventDefault();
  e.stopPropagation();
}
["dragenter", "dragover", "dragleave", "drop"].forEach(ev => document.addEventListener(ev, preventDefaults, false));
export function componentsInitializer(targetAttr, apps) {
  let config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  document.addEventListener("DOMContentLoaded", event => {
    ajax.head(`${window.envs.authTarget}/touch`);
    document.body.addEventListener("click", e => eventBus.$emit(EVENTS.Body.Click, e));
    config.DOMContentLoaded && config.DOMContentLoaded();
    document.querySelectorAll(`[${targetAttr}]`).forEach(element => {
      const appComponent = apps[element.getAttribute(targetAttr)];
      const props = {};
      Object.keys(element.dataset).forEach(dsKey => {
        const ds = element.dataset[dsKey];
        delete element.dataset[dsKey];
        try {
          props[dsKey] = JSON.parse(ds);
        } catch (ex) {
          props[dsKey] = ds;
        }
      });
      const app = createApp(appComponent, props);
      app.config.globalProperties.$bag = {};
      app.config.globalProperties.$ajax = ajax;
      app.use(i18n);
      if (config.store) {
        app.use(config.store());
      }
      app.mount(element);
    });
  });
}
export function appInitializer(target, appComponent, routes) {
  let config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  document.addEventListener("DOMContentLoaded", function (event) {
    const app = createApp(appComponent);
    let mountFn = () => app.mount(document.getElementById(target));
    app.config.errorHandler = (err, vm, info) => {
      console.log(err);
      window.onerror && window.onerror("", "", "", "", err);
    };
    app.config.globalProperties.$bag = {};
    app.config.globalProperties.$ajax = ajax;
    app.use(i18n);
    if (config.store) {
      app.use(config.store());
    }
    if (routes) {
      const router = createRouter({
        routes,
        history: createWebHistory(),
        scrollBehavior(to, from, savedPosition) {
          if (savedPosition) return savedPosition;
          return {
            x: 0,
            y: 0
          };
        }
      });
      router.afterEach((to, from) => {
        ajax.head(`${window.envs.authTarget}/touch`);
        nextTick(() => eventBus.$emit(EVENTS.Navigation.PageChanged, {
          from,
          to
        }));
      });
      app.use(router);
      const oldMountFn = mountFn;
      mountFn = () => router.isReady().then(oldMountFn);
    }
    mountFn();
    WebFont.load({
      google: {
        families: ["Ubuntu:normal,medium,light,bold"]
      }
    });
  });
}